export const tagStyles = {
    height: '30px',
    borderWidth: '1px',
    iconSize: {
        small: '12px',
        medium: '14px',
    },
};
